//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Annotations/Annotations.LeaderBuilder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../Annotations/Annotations.MasterSymbolListItemBuilderList.js";
import "../no/Expression.js";
import "../no/ObjectList.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"AnnotationPreference",1,0],[0,"ControlledNoteTitle",1,0],[0,"GeometryPreference",1,0],[0,"HorizontalFlip",1,0],[0,"Integer",1,0],[0,"IsPartSymbol",1,0],[1,"Leader",0,"Annotations.LeaderBuilder",0],[0,"LockStatus",1,0],[0,"MasterSymbolName",1,0],[0,"MasterSymbolPath",1,0],[1,"Origin",0,"Annotations.OriginBuilder",0],[0,"PartiallyControlledNoteTitle",1,0],[0,"Real",1,0],[1,"Scale",0,"Expression",0],[0,"SmashSymbol",1,0],[1,"Style",0,"Annotations.StyleBuilder",0],[1,"Texts",0,"Annotations.MasterSymbolListItemBuilderList",0],[0,"VerticalFlip",1,0]],[[["nArbitraryNoteTitle"],"GetArbitraryNoteTitle",{R_:{arbitraryNoteTitle:""}},0,0],[["arbitraryNoteTitle"],"SetArbitraryNoteTitle",{},1,0],[["name"],"SelectSymbol",{},1,0],[["name","path"],"SelectPartSymbol",{},2,0],[["index"],"SelectText",{},1,0],[[],"GetSymbol",{R_:{customSymbol:"Annotations.BaseCustomSymbol"}},0,0]],[]];
SPLM.Annotations.BaseCustomSymbolBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.BaseCustomSymbolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.BaseCustomSymbolBuilder.AnnotationPreferences = Object.freeze({
    "UseCurrent" : "UseCurrent", "UseDefinition" : "UseDefinition"});

SPLM.Annotations.BaseCustomSymbolBuilder.GeometryPreferences = Object.freeze({
    "UseCurrent" : "UseCurrent", "UseDefinition" : "UseDefinition"});

export default SPLM;